import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=5060308e&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5060308e')) {
      api.createRecord('5060308e', component.options)
    } else {
      api.reload('5060308e', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=5060308e&", function () {
      api.rerender('5060308e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O4573992EJmS/JS/comp/childrenage.vue"
export default component.exports